@if (showAddNicknameModal) {
  <div class="modal-add-cart-name">
    <app-modal
        [open]="showAddNicknameModal"
        [id]="'changeQuoteName'"
        (crossClick)="emitCloseModalEvent()"
        (outsideClick)="emitCloseModalEvent()"
        title="{{ (hasNickname ? 'mini-cart.edit-nickname-label' : 'contract-steps-bar.quote-change-nickname') | translate }}">
      <ng-container ngProjectAs="[slot][body]">
        <div class="nickname-modal__content">
          <p class="modal-text" [attr.data-test]="'desc-add-nicknameText'">
            {{ (isContractInCart ? 'contract-steps-bar.quote-change-nickname-text' : 'contract-steps-bar.cart-change-nickname-text') | translate }}
          </p>
          <app-textfield
              class="nickname__input"
              [form]="form"
              [modelValue]="form.value.name"
              [inputName]="'name'"
              [readOnly]="savingNickNameInProgress"
              label="{{ (hasNickname ?
              'mini-cart.edit-nickname-label' :
              'contract-steps-bar.quote-change-nickname-label') | translate }}"
              [attr.data-test]="'input-add-nickname'">
          </app-textfield>
          <div class="nickname__alerts">
            @if (validateField('name', 'maxlength')) {
              <small class="textfield__hint"
                    [attr.data-test]="'hint-modalMaxCharacters'">
                {{ 'checkout-delivery-details-modal.max-characters' | translate: {charNumber: maxNameLength} }}
              </small>
            }
            @if (validateField('name', 'minlength')) {
              <small class="textfield__hint"
                    [attr.data-test]="'hint-modalMinCharacters'">
                {{ 'checkout-delivery-details-modal.min-characters' | translate: {charNumber: minNameLength} }}
              </small>
            }
            @if (validateField('name', 'valueHasAtLeastOneLetter')) {
              <small class="textfield__hint"
                    [attr.data-test]="'hint-modalMissingLetter'">
                {{ 'mini-cart.missing-letter' | translate }}
              </small>
            }
          </div>
        </div>
      </ng-container>
      <ng-container ngProjectAs="[slot][footer]">
        <button
            class="button button--standard"
            data-dismiss="modal-dialog"
            (click)="resetNickname()"
            [disabled]="form.value.name.length === 0"
            [attr.data-test]="'button-reset'">
          {{ 'contract-steps-bar.reset' | translate }}
        </button>
        <button
            type="submit"
            class="button button--primary"
            data-dismiss="modal-dialog"
            (click)="saveNewNickname()"
            [disabled]="form.value.name.length === 0 && !hasNickname"
            [attr.data-test]="'button-confirm'">
          {{ 'contract-steps-bar.quote-change-nickname-confirm-button' | translate }}
        </button>
      </ng-container>
    </app-modal>
  </div>
}
